import { twMerge } from '@faceup/ui'
import type { ComponentProps } from 'react'

export const InputLabel = ({ className, ...props }: ComponentProps<'span'>) => (
  <span
    className={twMerge(
      'my-2.5 inline-block font-semibold text-colorText text-sm leading-tight',
      className
    )}
    {...props}
  />
)
